import dayjs from 'dayjs';
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)


export const titleCase = (str) =>{
    return str.replace(
        /\w\S*/g,
        function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export const isEmpty = (obj) => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}


export const handleResponse = (response) => {
    return response.text().then(async (my_data) => {
        if (response.status === 500) {
            return Promise.reject({error: 'Error 500: Internal Server Error.'})
        }
        
        if (response.status === 404) {
            // alert("Error 404: Requested uri does not exist.", 'Invalid API URL')
            return Promise.reject({error: 'Error 404: Requested uri does not exist.'})
        }

        if (response.status === 401) {
            // AppStore.dispatch(AuthActions.logout())
            return Promise.reject({message: 'Unauthorised Access'})
            
        }

        if (response.status === 400) {
            const data = my_data && JSON.parse(my_data);
            return Promise.reject(data)
        }

        if (response.status === 422) {
            const data = my_data && JSON.parse(my_data);
            return Promise.reject({errors: data, message: 'Form validation failed!'})
        }

        const data = my_data && JSON.parse(my_data);
        if (!response.ok) {
            // throw Error(response.statusText);
            const error = (data?.error || data?.errors) || response.statusText;
            const message = data?.message || null
            return Promise.reject({error, message, data});
        } else {
            return data
        }
    })
    .catch(error => {
        return Promise.reject(error);
    });
}

export const requestTimeout = (ms, promise) => {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
        reject({error:'Server Request Timeout'})
        }, ms)      
        promise
        .then(value => {
            clearTimeout(timer)
            resolve(value)
        })
        .catch(reason => {
            clearTimeout(timer)
            reject(reason)
        })
    })
}


export const fromNow = (timestap) => {
    return dayjs(timestap).fromNow()
}

export const formatNumber = (number, locale = 'en-US') => {
    return new Intl.NumberFormat(locale).format(number);
}

// Turn a stats API `range` (UTC datetime strings, e.g. "2026-07-31 19:00:00")
// into a human label rendered in the user's local timezone. The trailing "Z"
// forces UTC parsing — without it the string is read as local time and the day
// can shift (e.g. a PKT month-start comes back as UTC and shows the prior day).
export const statsRangeLabel = (range, fallback = 'This Month') => {
    if (!range?.start || !range?.end) return fallback
    const start = new Date(range.start.replace(' ', 'T') + 'Z')
    const end = new Date(range.end.replace(' ', 'T') + 'Z')
    if (isNaN(start) || isNaN(end)) return fallback
    return `${dayjs(start).format('MMM D, YYYY')} - ${dayjs(end).format('MMM D, YYYY')}`
}
